import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { GameProvider } from '@shared/models/games/game-provider.model';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class GameProviderHttpService {
  isDemo$ = new BehaviorSubject<boolean>(true);
  isSlotsPage$ = new BehaviorSubject<boolean>(false);
  isFishingPage$ = new BehaviorSubject<boolean>(false);
  isLotteryPage$ = new BehaviorSubject<boolean>(false);
  isTablePage$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getGameBalance(params?: string): Observable<GameProvider[]> {
    return this.http.get<ApiResponse>(`/gameprovider/balance${params}`).pipe(
      map(res => res.data.rows)
    );
  }

  launchGame(params?: string): Observable<GameProvider[]> {
    const { isDesktop } = JSON.parse((localStorage.getItem('user_browser')));
    const deviceType = isDesktop ? 'desktop' : 'mobile';
    // const newParams = params.replace("category_code=CR", "category_code=SP");
    return this.http.get<ApiResponse>(`/gameprovider/launch${params}&device_type=${deviceType}`).pipe(
      map(res => res.data.rows)
    );
  }

  toggleSlotsDemoStorage(code? : string) {
    setTimeout(() => {
      if(localStorage.getItem('isDemoSelected') === undefined || localStorage.getItem('isDemoSelected') === null) {
        var isDemoSelected ={demo: 0, code : code};
        localStorage.setItem('isDemoSelected', JSON.stringify(isDemoSelected));
        this.isDemo$.next(false);
        return;
      }

      this.isDemo$.next(+JSON.parse(localStorage.getItem('isDemoSelected')).demo == 1 && JSON.parse(localStorage.getItem('isDemoSelected')).code == code ? true : false);
    });
  }
  
  // toggleCasinoDemoStorage(code? : string) {
  //   setTimeout(() => {
  //     if(localStorage.getItem('isDemoSelected') === undefined || localStorage.getItem('isDemoSelected') === null) {
  //       var isDemoSelected ={demo: 0, code : code};
  //       localStorage.setItem('isDemoSelected', JSON.stringify(isDemoSelected));
  //       this.isDemo$.next(false);
  //       return;
  //     }

  //     this.isDemo$.next(+JSON.parse(localStorage.getItem('isDemoSelected')).demo == 1 && JSON.parse(localStorage.getItem('isDemoSelected')).code == code ? true : false);
  //   });
  // }

  getWeeklyTurnover() {
    return this.http.get<ApiResponse>(`/gameprovider/getweeklyturnover`).pipe(
      map(res => res.data)
    );
  }

  getSitemap(params = ''): Observable<any[]> {
      return this.http.get<ApiResponse>(`/gameprovider/sitemap` + params).pipe(
          map(res => res.data.rows)
      );
  }

}
